require("@fancyapps/fancybox");
$(document).ready(function() {
	$('[data-fancybox]').fancybox({
		autoFocus: false,
		buttons: [
			"zoom",
			"close"
		]
	});
});